import { metadataLoader } from "../../auto/js/metadata";

export const loadLocaleId = () => {
    return metadataLoader.load('locale');
}

